var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolDefs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M4 12h16M4 12l6-6M4 12l6 6"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-camera",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M12 16c1.657 0 3-1.343 3-3s-1.343-3-3-3c-1.657 0-3 1.343-3 3s1.343 3 3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M3 9c0-1.105 0.895-2 2-2h2.5c0.552 0 1-0.448 1-1s0.448-1 1-1h5c0.552 0 1 0.448 1 1s0.448 1 1 1h2.5c1.105 0 2 0.895 2 2v8c0 1.105-0.895 2-2 2h-14c-1.105 0-2-0.895-2-2v-8z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M20 7l-11 11-5-5"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check-round",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M17 9l-7 7-3-3M8 20h8c2.209 0 4-1.791 4-4v-8c0-2.209-1.791-4-4-4h-8c-2.209 0-4 1.791-4 4v8c0 2.209 1.791 4 4 4z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M4 9l8 8 8-8"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M20 15l-8-8-8 8"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-clock",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.44,
    d: "M12.247 7.2v4.8l2.88 2.88M20.887 12c0 4.772-3.868 8.64-8.64 8.64s-8.64-3.868-8.64-8.64c0-4.772 3.868-8.64 8.64-8.64s8.64 3.868 8.64 8.64z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cross",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M19 5l-14 14M5 5l14 14"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cross-small",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M16 8l-8 8M8 8l8 8"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 15.706l-0.53-0.53c-0.136 0.136-0.22 0.323-0.22 0.53v0h0.75zM15.706 5l0.53-0.53c-0.136-0.136-0.323-0.219-0.53-0.219s-0.394 0.084-0.53 0.219v0l0.53 0.53zM19 8.294l0.53 0.53c0.136-0.136 0.219-0.323 0.219-0.53s-0.084-0.394-0.219-0.53v0l-0.53 0.53zM8.294 19v0.75c0.207-0 0.394-0.084 0.53-0.22v0l-0.53-0.53zM5 19h-0.75c0 0.414 0.336 0.75 0.75 0.75v-0.75zM11.588 18.25c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0-1.5zM18.588 19.75c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0 1.5zM5.53 16.236l10.706-10.706-1.060-1.060-10.706 10.706 1.060 1.060zM15.176 5.53l3.294 3.294 1.060-1.060-3.294-3.294-1.060 1.060zM18.47 7.764l-10.706 10.706 1.060 1.060 10.706-10.706-1.060-1.060zM8.294 18.25h-3.294v1.5h3.294v-1.5zM5.75 19v-3.294h-1.5v3.294h1.5zM12.705 8l3.294 3.295 1.060-1.060-3.293-3.295-1.061 1.060zM11.588 19.75h7v-1.5h-7v1.5z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-female",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.44,
    d: "M12.247 12.96c2.651 0 4.8-2.149 4.8-4.8s-2.149-4.8-4.8-4.8c-2.651 0-4.8 2.149-4.8 4.8s2.149 4.8 4.8 4.8zM12.247 12.96v7.68M9.367 17.76h5.76"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filters",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M14 5c0-1.105-0.895-2-2-2s-2 0.895-2 2M14 5c0 1.105-0.895 2-2 2s-2-0.895-2-2M14 5h6M10 5h-6M16 12c0 1.105 0.895 2 2 2s2-0.895 2-2c0-1.105-0.895-2-2-2s-2 0.895-2 2zM16 12h-12M8 19c0-1.105-0.895-2-2-2s-2 0.895-2 2c0 1.105 0.895 2 2 2s2-0.895 2-2zM8 19h12"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.44,
    d: "M4.567 4.32l4.8 7.68v5.76l5.76 2.88v-8.64l4.8-7.68h-15.36z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-heart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M4.331 12.047l7.669 7.953 7.669-7.953c0.852-0.884 1.331-2.083 1.331-3.333 0-2.604-2.035-4.714-4.546-4.714-1.206 0-2.362 0.497-3.214 1.381l-1.24 1.286-1.24-1.286c-0.853-0.884-2.009-1.381-3.214-1.381-2.511 0-4.546 2.111-4.546 4.714 0 1.25 0.479 2.449 1.331 3.333z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-heart-fill",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3314 12.0474L12 20L19.6686 12.0474C20.5211 11.1633 21 9.96429 21 8.71405C21 6.11055 18.9648 4 16.4543 4C15.2487 4 14.0925 4.49666 13.24 5.38071L12 6.66667L10.76 5.38071C9.90749 4.49666 8.75128 4 7.54569 4C5.03517 4 3 6.11055 3 8.71405C3 9.96429 3.47892 11.1633 4.3314 12.0474Z",
    fill: "#54ADFF",
    stroke: "#54ADFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-location",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.44,
    d: "M19.927 11.040c0 4.242-3.438 7.68-7.68 9.6-4.242-1.92-7.68-5.358-7.68-9.6s3.438-7.68 7.68-7.68c4.242 0 7.68 3.438 7.68 7.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.44,
    d: "M15.127 11.040c0 1.591-1.289 2.88-2.88 2.88s-2.88-1.289-2.88-2.88c0-1.591 1.289-2.88 2.88-2.88s2.88 1.289 2.88 2.88z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M14 4h4c1.105 0 2 0.895 2 2v12c0 1.105-0.895 2-2 2h-4M3 12h12M3 12l4-4M3 12l4 4"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-male",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.44,
    d: "M12.247 11.040c-2.651 0-4.8 2.149-4.8 4.8s2.149 4.8 4.8 4.8c2.651 0 4.8-2.149 4.8-4.8s-2.149-4.8-4.8-4.8zM12.247 11.040v-7.68M12.247 3.36l3.84 3.84M12.247 3.36l-3.84 3.84"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-burger",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M4 7h16M4 12h16M4 17h16"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-paw",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.361 14.362c-0.273-2.013-1.542-3.679-3.287-4.503l-0.035-0.015c-0.724-0.347-1.573-0.55-2.471-0.55-1.16 0-2.241 0.339-3.148 0.924l0.023-0.014-4.074 2.579c-0.667 0.425-1.179 1.041-1.464 1.77l-0.009 0.025c-0.158 0.394-0.249 0.851-0.249 1.33 0 0.353 0.050 0.694 0.142 1.016l-0.006-0.026c0.222 0.788 0.677 1.45 1.286 1.924l0.008 0.006c0.631 0.491 1.388 0.76 2.189 0.778l0.052 0.001c2.090 0.065 3.948 1.003 5.233 2.459l0.007 0.008c0.512 0.583 1.198 1.001 1.978 1.173l0.024 0.005c0.234 0.053 0.504 0.084 0.78 0.084 0.555 0 1.081-0.123 1.553-0.343l-0.023 0.009c0.731-0.336 1.317-0.881 1.695-1.558l0.010-0.019c0.388-0.7 0.536-1.49 0.43-2.283l-0.644-4.779zM13.287 21.721c-0.927 0.421-2 0.19-2.672-0.575-0.781-0.887-1.729-1.606-2.797-2.114l-0.053-0.022c-1.015-0.485-2.203-0.781-3.457-0.81l-0.010-0-0.035-0.001c-1.014-0.035-1.858-0.726-2.12-1.661l-0.004-0.016c-0.054-0.186-0.086-0.399-0.086-0.619 0-0.81 0.422-1.521 1.058-1.925l0.009-0.006 4.075-2.58c0.672-0.434 1.492-0.691 2.373-0.691 0.681 0 1.327 0.154 1.903 0.43l-0.027-0.011c1.351 0.637 2.314 1.902 2.519 3.407l0.003 0.023 0.643 4.78c0.014 0.094 0.022 0.202 0.022 0.313 0 0.92-0.545 1.713-1.33 2.073l-0.014 0.006zM4.721 9.395c0.828 0.058 1.624-0.259 2.244-0.892 0.59-0.602 0.948-1.426 1.010-2.318 0.060-0.892-0.182-1.757-0.682-2.435-0.527-0.711-1.272-1.135-2.099-1.192-1.662-0.115-3.12 1.325-3.252 3.211-0.103 1.502 0.668 2.84 1.825 3.38 0.296 0.137 0.617 0.223 0.954 0.246zM3.346 5.865c0.077-1.11 0.863-1.965 1.752-1.903 0.16 0.010 0.316 0.052 0.463 0.12 0.227 0.106 0.432 0.277 0.6 0.505 0.303 0.409 0.448 0.942 0.41 1.501s-0.256 1.067-0.612 1.431c-0.326 0.333-0.731 0.501-1.14 0.473-0.889-0.061-1.55-1.015-1.473-2.126zM10.641 8.647c1.762 0.821 3.957-0.143 4.893-2.15 0.936-2.008 0.264-4.31-1.498-5.131-1.761-0.822-3.956 0.143-4.892 2.15-0.936 2.008-0.264 4.31 1.497 5.13zM13.442 2.641c1.059 0.493 1.425 1.956 0.817 3.261-0.608 1.304-1.965 1.963-3.023 1.47-1.059-0.494-1.425-1.957-0.817-3.26 0.608-1.305 1.964-1.965 3.023-1.471zM15.744 12.114c0.229 0.216 0.485 0.388 0.76 0.517 1.285 0.599 2.974 0.248 4.122-0.967 0.66-0.699 1.050-1.582 1.097-2.486 0.050-0.947-0.278-1.804-0.923-2.413-0.644-0.608-1.518-0.888-2.46-0.785-0.901 0.098-1.76 0.536-2.421 1.236-1.394 1.474-1.472 3.672-0.175 4.898zM16.941 8.182c0.432-0.457 0.982-0.742 1.55-0.804 0.526-0.057 1.003 0.089 1.343 0.41 0.34 0.32 0.512 0.789 0.484 1.317-0.030 0.57-0.283 1.136-0.715 1.593-0.86 0.91-2.159 1.088-2.893 0.394-0.733-0.694-0.63-2 0.231-2.91zM22.67 14.827c-0.797-1.465-2.795-1.923-4.456-1.022-1.66 0.902-2.363 2.827-1.569 4.29 0.29 0.535 0.74 0.935 1.274 1.185 0.933 0.435 2.125 0.411 3.181-0.162 1.66-0.902 2.364-2.827 1.57-4.291zM20.43 17.882c-0.98 0.531-2.124 0.326-2.548-0.457s0.026-1.852 1.004-2.384c0.65-0.353 1.372-0.38 1.909-0.13 0.271 0.126 0.496 0.324 0.639 0.587 0.424 0.783-0.027 1.852-1.005 2.384z"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-paw-load",
    viewBox: "0 0 249 209.32"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.917,
    cy: 106.333,
    strokeWidth: 0,
    rx: 27.917,
    ry: 35.833
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.75,
    cy: 47.749,
    strokeWidth: 0,
    rx: 34.75,
    ry: 47.751
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162,
    cy: 47.749,
    strokeWidth: 0,
    rx: 34.75,
    ry: 47.751
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.083,
    cy: 106.333,
    strokeWidth: 0,
    rx: 27.917,
    ry: 35.833
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M43.98 165.39s9.76-63.072 76.838-64.574c0 0 71.082-6.758 83.096 70.33 0 0 2.586 19.855-12.54 31.855 0 0-15.75 17.75-43.75-6.25 0 0-7.124-8.374-24.624-7.874 0 0-12.75-.125-21.5 6.625 0 0-16.375 18.376-37.75 12.75 0 0-28.29-7.72-19.77-42.86z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M12 20v-8M12 12v-8M12 12h8M12 12h-8"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus-small",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M12 7v10M7 12h10"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-round",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.5,
    d: "M4 8c0-2.209 1.791-4 4-4h8c2.209 0 4 1.791 4 4v8c0 2.209-1.791 4-4 4h-8c-2.209 0-4-1.791-4-4v-8z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.47 20.53c0.293 0.293 0.768 0.293 1.061 0s0.293-0.768 0-1.061l-1.061 1.061zM17.25 10.5c0 3.728-3.022 6.75-6.75 6.75v1.5c4.556 0 8.25-3.694 8.25-8.25h-1.5zM10.5 17.25c-3.728 0-6.75-3.022-6.75-6.75h-1.5c0 4.556 3.694 8.25 8.25 8.25v-1.5zM3.75 10.5c0-3.728 3.022-6.75 6.75-6.75v-1.5c-4.556 0-8.25 3.694-8.25 8.25h1.5zM10.5 3.75c3.728 0 6.75 3.022 6.75 6.75h1.5c0-4.556-3.694-8.25-8.25-8.25v1.5zM20.53 19.47l-4.188-4.188-1.061 1.061 4.188 4.188 1.061-1.061z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.6364,
    d: "M1.091 12c0 0 3.967-7.636 10.909-7.636s10.909 7.636 10.909 7.636-3.967 7.636-10.909 7.636c-6.942 0-10.909-7.636-10.909-7.636z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.6364,
    d: "M12 15.273c1.808 0 3.273-1.465 3.273-3.273s-1.465-3.273-3.273-3.273c-1.807 0-3.273 1.465-3.273 3.273s1.465 3.273 3.273 3.273z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close-eye",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.6364,
    d: "M9.561 4.686c0.766-0.205 1.58-0.322 2.439-0.322 6.942 0 10.909 7.636 10.909 7.636s-0.904 1.741-2.605 3.56M3.654 8.485c-1.673 1.803-2.563 3.515-2.563 3.515s3.967 7.636 10.909 7.636c0.875 0 1.703-0.121 2.481-0.333M11.455 15.227c-1.183-0.198-2.15-1.031-2.541-2.137M12.545 8.773c1.371 0.23 2.452 1.312 2.682 2.682M2.182 2.182l19.636 19.636"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    d: "M18 6v12c0 1.105-0.895 2-2 2h-8c-1.105 0-2-0.895-2-2v-12M15 6v-1c0-1.105-0.895-2-2-2h-2c-1.105 0-2 0.895-2 2v1M4 6h16M10 10v6M14 10v6"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffc107",
    style: {
      stroke: "var(--color2, #ffc107)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.2857,
    d: "M18.857 20.571v-1.714c0-1.894-1.535-3.429-3.429-3.429h-6.857c-1.894 0-3.429 1.535-3.429 3.429v1.714M15.429 8.571c0 1.894-1.535 3.429-3.429 3.429s-3.429-1.535-3.429-3.429c0-1.894 1.535-3.429 3.429-3.429s3.429 1.535 3.429 3.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffc107",
    style: {
      stroke: "var(--color2, #ffc107)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.2857,
    d: "M12 0.643c6.272 0 11.357 5.085 11.357 11.357s-5.085 11.357-11.357 11.357c-6.272 0-11.357-5.085-11.357-11.357s5.085-11.357 11.357-11.357z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDefs);
export default __webpack_public_path__ + "static/media/symbol-defs.077a122beb27e7b9292d366902f646e3.svg";
export { ForwardRef as ReactComponent };